import React, { useRef } from 'react';
import { useCountUp } from 'react-countup';
import { useInView } from 'react-intersection-observer';

const CountUpCounter = ({ countNumber }) => {
  const spanRef = useRef(null);

  const { start } = useCountUp({
    ref: spanRef,
    duration: 5,
    start: 0,
    end: countNumber,
    useEasing: true,
    startOnMount: false,
  });

  const { ref } = useInView({
    triggerOnce: true,
    threshold: 1,
    onChange: (inView) => inView && start(),
  });

  return (
    // if div is in view, start count animation
    <div className="counter-element" ref={ref}>
      <span ref={spanRef} />
    </div>
  );
};

export default CountUpCounter;
